import { render, staticRenderFns } from "./VerificationConfirmModal.vue?vue&type=template&id=e06734ba&"
import script from "./VerificationConfirmModal.vue?vue&type=script&lang=js&"
export * from "./VerificationConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports